import moment from 'moment/src/moment';

export const getTodayStartTime = () => window.parseInt(moment().startOf('day').format('x')) || null;
export const getTodayEndTime = () => window.parseInt(moment().endOf('day').format('x')) || null;

export const getTommorrowStartTime = () => window.parseInt(moment().add(1, 'd').startOf('day').format('x')) || null;
export const getTommorrowEndTime = () => window.parseInt(moment().add(1, 'd').endOf('day').format('x')) || null;

export const getThisWeekStartTime = () => window.parseInt(moment().startOf('week').format('x')) || null;
export const getThisWeekEndTime = () => window.parseInt(moment().endOf('week').format('x')) || null;

export const getNextWeekStartTime = () => window.parseInt(moment().add(1, 'w').startOf('week').format('x')) || null;
export const getNextWeekEndTime = () => window.parseInt(moment().add(1, 'w').endOf('week').format('x')) || null;

export const getLastWeekStartTime = () => window.parseInt(moment().subtract(1, 'w').startOf('week').format('x')) || null;
export const getLastWeekEndTime = () => window.parseInt(moment().subtract(1, 'w').endOf('week').format('x')) || null;

export const getThisMonthStartTime = () => window.parseInt(moment().startOf('month').format('x')) || null;
export const getThisMonthEndTime = () => window.parseInt(moment().endOf('month').format('x')) || null;

export const getNextMonthStartTime = () => window.parseInt(moment().add(1, 'M').startOf('month').format('x')) || null;
export const getNextMonthEndTime = () => window.parseInt(moment().add(1, 'M').endOf('month').format('x')) || null;

export const getLastMonthStartTime = () => window.parseInt(moment().subtract(1, 'M').startOf('month').format('x')) || null;
export const getLastMonthEndTime = () => window.parseInt(moment().subtract(1, 'M').endOf('month').format('x')) || null;

export const getThisQuartersStartTime = () => window.parseInt(moment().startOf('quarter').format('x')) || null;
export const getThisQuartersEndTime = () => window.parseInt(moment().endOf('quarter').format('x')) || null;

export const getNextQuartersStartTime = () => window.parseInt(moment().add(1, 'Q').startOf('quarter').format('x')) || null;
export const getNextQuartersEndTime = () => window.parseInt(moment().add(1, 'Q').endOf('quarter').format('x')) || null;

export const getLastQuartersStartTime = () => window.parseInt(moment().subtract(1, 'Q').startOf('quarter').format('x')) || null;
export const getLastQuartersEndTime = () => window.parseInt(moment().subtract(1, 'Q').endOf('quarter').format('x')) || null;

export const getDiffInMinutes = (timestamp) => moment().diff(timestamp, 'minutes');

/**
 * Converts a date to its end-of-day timestamp (epoch ms) — how the app stores due dates
 * (see kerika-date-picker-dialog). Accepts a `yyyy-MM-dd` string (e.g. "2026-08-08").
 * Returns null for null/'', and passes an existing number through unchanged.
 */
export const getDateEndTime = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'number') return value;
  const timeStamp = window.parseInt(moment(value).endOf('day').format('x'));
  return Number.isNaN(timeStamp) ? null : timeStamp;
};

/**
 * Parses free-typed text into an `{hours, minutes}` pair, colon or not - "1019am", "10:19am",
 * "10:19 AM" all land on the same value. Shared by the Stop Timer dialog's Start/End fields and
 * `kerika-time-input`.
 * @param {String} value raw input text
 * @returns {Object|null} `{hours, minutes, ambiguous}`, or `null` if unparseable. `ambiguous` is
 *  `true` when no AM/PM was typed and the hour could be either half of the day.
 */
export const parseTimeText = (value) => {
  const normalized = String(value || '').trim().toUpperCase().replace(/\s+/g, '');
  if (!normalized) {
    return null;
  }
  // 'hA'/'H' read an hour typed on its own ("12", "9") as that hour with :00 minutes -
  // common time pickers accept it, and requiring the full 4 digits before anything
  // parses made the field feel broken on the first two keystrokes of any entry.
  const parsed = moment(normalized, ['h:mmA', 'hmmA', 'H:mm', 'Hmm', 'hA', 'H'], true);
  if (!parsed.isValid()) {
    return null;
  }
  const hours = parsed.hours();
  // moment's own answer, not a pattern over the text: it accepts "p", "PM" and "a.m."
  // alike, and a pattern written for those missed the dotted spellings.
  const meridiemTyped = !!parsed.parsingFlags().meridiem;
  return {
    hours,
    minutes: parsed.minutes(),
    ambiguous: !meridiemTyped && hours >= 1 && hours <= 12,
  };
};
